module.exports = __webpack_public_path__ + "img/assiopay_logo.04d7dc3f.png";